<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.deployments')}`">
              <div class="v-table">
                <TableServer type="deployments" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-deployment')}`">
              <DeploymentForm v-if="spawnerAdminSchemas.forms['Deployment']" />
            </b-tab>
            <b-tab
              v-if="deploymentId !== null && adminDeployment.id > 0"
              :title="`${this.$i18n.t('JSON.deployment')}#${deploymentId}`"
            >
              <DeploymentForm
                v-if="spawnerAdminSchemas.forms['Deployment']"
                :deployment="adminDeployment"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
    DeploymentForm: () => import('@/components/admin/spawner/modals/forms/DeploymentForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    deploymentId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      adminDeployment: (state) => state.adminDeployment.adminDeployment,
    }),

    modalId() {
      return 'deployment';
    },
  },

  watch: {
    deploymentId(newValue) {
      if (newValue !== null) {
        this.loadSpawnerAdminDeployment();
      }
    },
  },

  methods: {
    ...mapActions(['getSpawnerAdminDeployment']),

    async loadSpawnerAdminDeployment() {
      try {
        await this.getSpawnerAdminDeployment({
          params: {
            tid: this.deploymentId,
          },
        });

        // console.log('deployment', this.deployment);

        // success
        // console.log('success loading deployment!');
      } catch (error) {
        // error
        // console.log('error loading deployment!');
      }
    },

    onOpened() {
      if (this.deploymentId !== null) {
        this.loadSpawnerAdminDeployment();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
